import classNames from 'classnames';

import { documentTypeIconsMap } from 'consts/documentIcons';
import { File } from 'types/models/File';
import { ProductDocumentTypeId } from 'types/models/ProductDocumentType';
import Typography from '@components/atoms/Typography';
import FilePreviewModal from '@components/FilePreviewModal';
import resolveDocumentData from 'utils/resolveDocumentData';

import classes from './DocumentsList.module.scss';

type Props = {
  documents: {
    name: string;
    productDocumentTypeId: ProductDocumentTypeId;
    file: Pick<File, 'id' | 'name' | 'basename' | 'extension'>;
  }[];
  className?: string;
};

const DocumentsList = ({ className, documents }: Props): JSX.Element => (
  <div className={classNames(classes.wrapper, className)}>
    {documents.map(({ name, productDocumentTypeId, file }) => {
      const IconComponent = documentTypeIconsMap[productDocumentTypeId];
      const { url, fileName } = resolveDocumentData({ name, file });

      return (
        <FilePreviewModal
          key={file.id}
          fileType={productDocumentTypeId}
          fileName={name}
          fileUrl={url}
          downloadFileName={fileName}
        >
          {({ onClick }) => (
            <div className={classes.itemWrapper} onClick={onClick}>
              <div className={classes.iconWrapper}>
                <IconComponent />
              </div>
              <Typography variant="body1" renderAs="div" lineHeight="18px">
                {name}
              </Typography>
            </div>
          )}
        </FilePreviewModal>
      );
    })}
  </div>
);

export default DocumentsList;
